import { reactive } from "vue";
import { Options } from "vue-class-component";

import config from "@/config/config";
import i18n from "@/translation/i18n";
import PageBaseList from "@/pages/PageBaseList";
import TableLite from "@/components/table/TableLiteTs.vue";
import { Customer } from "@/domain/customer.model";
import Toggle from "@vueform/toggle/src/Toggle";

const { t } = i18n.global;

@Options({
  name: "reports-customer-newsletter",
  components: {
    TableLite,
    Toggle,
  },
  computed: {
    isLoading(): boolean {
      return this.$store.state.reports.isLoading;
    },
    totalRecordCount(): number {
      return this.$store.state.reports.reportCustomerNewsletter?.total;
    },
    report(): Customer[] {
      return this.$store.state.reports.reportCustomerNewsletter?.data;
    },
  },
  watch: {
    report: function () {
      this.table.rows = this.report;
      this.table.totalRecordCount = this.totalRecordCount;
    },
    isLoading: function () {
      this.table.isLoading = this.isLoading;
    },
  },
})
export default class CustomerNewslleter extends PageBaseList {
  public table = TABLE;
  public filterReports = {
    name: "",
    email: "",
    enabled: true,
  };

  public listaExcelFields = {
    id: "id",
    name: "name",
    email: "email",
    accept_newsletter: "accept_newsletter",
    enabled: "enabled",
    createdAt: "createdAt",
    updatedAt: "updatedAt",
  };

  public mounted(): void {
    this.module = config.modules.customer;
    this.table.rows = [];

    this.doSearch(0, this.per_page, "id", "asc");
  }

  public computed(): void {
    this.module = config.modules.customer;
    this.table.rows = [];

    this.doSearch(0, this.per_page, "id", "asc");
  }

  public doFilter() {
    this.doSearch(0, this.per_page, "id", "asc", this.filterReports);
  }

  public clear() {
    this.filterReports = {
      name: "",
      email: "",
      enabled: true,
    };

    this.doSearch(0, this.per_page, "id", "asc");
  }

  public doSearch(offset?: number, limit?: number, order?: string, sort?: string, filter?: Record<string, unknown>) {
    this.table.isReSearch = offset == undefined ? true : false;

    if (offset >= 10 || limit >= this.max_per_page) {
      limit = this.max_per_page;
    }

    this.$store
      .dispatch("reports/customerNewsletterList", { offset, limit, order, sort, filter })
      .then(() => {
        this.table.sortable.order = order;
        this.table.sortable.sort = sort;
      })
      .catch(error => {
        console.log(error);
      });
  }

  public gerarExcel(filter?: Record<string, unknown>) {
    return this.$store.dispatch("reports/customerNewsletterExport", filter);
  }
}

export const TABLE = reactive({
  isLoading: false,
  isReSearch: false,
  columns: [
    {
      label: t("labels.entity.id"),
      field: "id",
      sortable: true,
      isKey: true,
    },
    {
      label: t("labels.entity.name"),
      field: "name",
      sortable: true,
      columnStyles: "text-align: left",
    },
    {
      label: t("labels.entity.email"),
      field: "email",
      sortable: true,
      columnStyles: "text-align: left",
    },
    {
      label: t("labels.entity.acceptNewsletter"),
      field: "accept_newsletter",
      sortable: true,
      columnStyles: "text-align: center",
    },
    {
      label: t("labels.entity.active"),
      field: "enabled",
      sortable: true,
      columnStyles: "text-align: center",
    },
  ],
  rows: [{}],
  totalRecordCount: 0,
  sortable: {
    order: "id",
    sort: "asc",
  },
});
